import React, { useEffect } from "react";

import useTranslations from "containers/hooks/useLanguageHook";
import { useWindowSize } from "containers/hooks/useWindowSize";
import SparkLines from "containers/Visuals/SparkLines";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { useAppDispatch } from "index";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
const SparklinesImage = new URL("../../../public/sparkline.png", import.meta.url).href;

function SparklinePage() {
  const { width, height } = useWindowSize();
  const { t } = useTranslations();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Sparklines));
  }, []);

  return (
    <VisPageWrapper
      title={t.Vis.SparkLines}
      help={{
        title: t.LandingPage.SparklinesTitle,
        description: t.LandingPage.SparklinesText,
        image: SparklinesImage,
      }}
    >
      <SparkLines
        settings={{
          width,
          height,
        }}
      />
    </VisPageWrapper>
  );
}

export { SparklinePage };
